@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.voiceassistant

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantPromptsDto
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantSettingsDto

object GetVoiceAssistantSettingsEndpoint :
    EndPoint<GetVoiceAssistantSettingsEndpoint.Request, GetVoiceAssistantSettingsEndpoint.Response>() {
    class Request
    class Response(val settings: VoiceAssistantSettingsDto, val defaultPrompts: VoiceAssistantPromptsDto)
}
